<script type="ts">
	import type { IThemedToken } from "shiki";
	import Token from "./Token.svelte";
	export let tokens: IThemedToken[];
</script>
<div class="line">
{#each tokens as token}<Token {token} />{/each}
</div>